module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.10/frontend/_next/static/images/mobile-banner-2d3b115e1d58a8d37b966144668bc5b6.png";